import { ChangeDetectionStrategy, Component, inject, Input, OnInit } from "@angular/core";
import { RouterLink } from "@angular/router";
import { TranslateModule } from "@ngx-translate/core";
import { NotificationDataService } from "@shared/services/notification-data/notification-data.service";

@Component({
  selector: "app-notification-bell",
  templateUrl: "./notification-bell.component.html",
  styleUrls: ["./notification-bell.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [RouterLink, TranslateModule],
})
export class NotificationBellComponent implements OnInit {
  @Input() bell: boolean = false;

  protected readonly notificationData: NotificationDataService =
    inject(NotificationDataService);

  ngOnInit(): void {
    this.notificationData.loadNotifications();
  }
}
